import { compact } from 'lodash';
import htmlDataDefaults from 'ricos-schema/dist/statics/html.defaults.json';
import { Node_Type } from 'ricos-types';
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from 'wix-rich-content-editor-common';
import { htmlButtonsTypes } from './defaults.js';
import { HTML_TYPE } from './types.js';
import { HTMLData_Source } from 'ricos-schema';
import InsertPluginIcon from './icons/InsertPluginIcon.js';
import Adsense from './icons/Adsense.js';
import 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getAddButtons = (config, _services) => {
  const { exposeButtons = [htmlButtonsTypes.html], siteDomain } = config || {};
  const index = exposeButtons.indexOf(htmlButtonsTypes.adsense);
  if (!siteDomain && index > -1) {
    exposeButtons.splice(index, 1);
  }
  const buttonsMap = {
    [htmlButtonsTypes.html]: {
      id: `${Node_Type.HTML}.html`,
      label: INSERT_PLUGIN_BUTTONS.HTML,
      dataHook: INSERT_PLUGIN_BUTTONS.HTML,
      icon: InsertPluginIcon,
      tooltip: "HtmlPlugin_InsertButton_Tooltip",
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: (editorCommands) => {
        editorCommands.insertBlockWithBlankLines(HTML_TYPE, htmlDataDefaults);
        return true;
      },
      menuConfig: {
        tags: "Video_plugin_search_tags"
      }
    },
    [htmlButtonsTypes.adsense]: {
      id: `${Node_Type.HTML}.adsense`,
      label: INSERT_PLUGIN_BUTTONS.ADSENSE,
      dataHook: INSERT_PLUGIN_BUTTONS.ADSENSE,
      icon: Adsense,
      tooltip: "AdSensePlugin_InsertButton_Tooltip",
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: (editorCommands) => {
        editorCommands.insertBlockWithBlankLines(HTML_TYPE, __spreadProps(__spreadValues({}, htmlDataDefaults), {
          source: HTMLData_Source.ADSENSE
        }));
        return true;
      },
      menuConfig: {
        tags: "Video_plugin_search_tags",
        group: "embed"
      }
    }
  };
  return compact(exposeButtons.map((buttonType) => buttonsMap[buttonType]));
};

export { getAddButtons };
//# sourceMappingURL=getAddButtons.js.map
